import React, { type PropsWithChildren } from 'react';

import { InfiniteScroll } from './InfiniteScroll';
import { useInfiniteScroll } from './useInfiniteScroll';

export interface InfiniteScrollWithFetchProps {
  itemsCount: number;
  totalRecords: number;
  fetchMore?: (offset: number) => Promise<void>;
  loadMoreOffset?: number;
  containerRef?: React.MutableRefObject<HTMLElement | null>;
  callbackOnEveryIntersection?: boolean;
}

/**
 * Consumers of this component have to register the used query with pagination options in
 * apolloClient.ts (initialization of InMemoryCache). This ensures that the results of fetchMore
 * will be concatenated to existing results.
 */
export const InfiniteScrollWithFetch: React.FC<PropsWithChildren<InfiniteScrollWithFetchProps>> = ({
  children,
  itemsCount,
  totalRecords,
  fetchMore,
  loadMoreOffset = 100,
  containerRef,
  callbackOnEveryIntersection,
}) => {
  const infiniteScrollProps = useInfiniteScroll({
    itemsCount,
    totalRecords,
    fetchMore,
    loadMoreOffset,
    isLoading: false,
  });

  return (
    <InfiniteScroll
      {...infiniteScrollProps}
      loadMoreOffset={loadMoreOffset}
      containerRef={containerRef}
      callbackOnEveryIntersection={callbackOnEveryIntersection}
    >
      {children}
    </InfiniteScroll>
  );
};
